import React, {ReactNode} from "react";
import {AppBar, Box, IconButton, Toolbar, useMediaQuery, useTheme} from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import {useDrawer} from "../drawer/DrawerProvider";
import {UserCard} from "./UserCard";
import {AppSubTitle} from "./AppSubTitle";
import {KurzLogo} from "../logo/KurzLogo";
import {palette} from "../../technical/style/theme";

export function CustomAppBar(props: {
  children?: ReactNode,
}) {

  const {toggleDrawer} = useDrawer();
  const theme = useTheme();
  const smallScreens = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <AppBar position="relative" elevation={3} sx={{
      backgroundColor: theme.palette.background.light,
      color: theme.palette.primary.main,
      paddingRight: theme.spacing(3),
      zIndex: 100,
    }}>
      {smallScreens &&
        <>
          <Toolbar>
            <IconButton
              aria-label="open drawer"
              edge="start"
              onClick={toggleDrawer}
              sx={{
                marginRight: theme.spacing(2),
                [theme.breakpoints.up('md')]: {
                  display: 'none',
                },
              }}
              size="large">
              <MenuIcon/>
            </IconButton>
            <KurzLogo sx={{
              position: 'absolute',
              right: 0,
              width: '110px',
              height: 'auto',
              color: palette.kurzBlue,
            }}/>
          </Toolbar>
          {props.children &&
            <Toolbar>
              {props.children}
            </Toolbar>
          }
        </>
      }
      {!smallScreens &&
        <Toolbar disableGutters={true}>
          <IconButton
            aria-label="open drawer"
            edge="start"
            onClick={toggleDrawer}
            sx={{
              marginRight: theme.spacing(2),
              [theme.breakpoints.up('md')]: {
                display: 'none',
              },
            }}
            size="large">
            <MenuIcon/>
          </IconButton>
          <AppSubTitle/>
          {props.children}
          <Box sx={{position: 'absolute', right: '110px', marginRight: theme.spacing(1)}}>
            <UserCard/>
          </Box>
          <KurzLogo sx={{
            position: 'absolute',
            right: 0,
            width: '110px',
            height: 'auto',
            color: palette.kurzBlue,
          }}/>
        </Toolbar>
      }
    </AppBar>
  );
}
